(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('profileMsTeamsTeamInfo', ["path", "$q", "mainQueueTroubleshootingHelper", "widgetPolling", "fileDao", "sideMenuManager", "modulesDao", "metaInfoConverter", "rolesManager", "$interval", "http", "sqlQueries", function (path, $q, mainQueueTroubleshootingHelper, widgetPolling, fileDao, sideMenuManager, modulesDao, metaInfoConverter, rolesManager, $interval, http, sqlQueries) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('profile/ms_teams_team/ms_teams-team-info').template('ms_teams-team-info'),
            scope: {},
            link: function ($scope, element, attrs) {
                var id = widgetPolling.scope().id;
                var updateTick = 30000;
                var restoreUpdateTickAfter;
                var updateWidget;
                function restartUpdating(promise, tick) {
                    if (promise) {
                        $interval.cancel(promise);
                    }
                    return $interval(function () {
                        $scope.loadData();
                    }, tick || 30000);
                }
                $scope.widgetApi = {};
                $scope.model = {};
                $scope.loadData = function () {
                    return $q.allSettled([
                        fileDao.entityInfo('ms_teams_team', id),
                        http.get(sqlQueries('team_members', false, 'ms_teams')).params({ team_id: id })
                    ]).then(function (responses) {
                        var input = {};
                        input.originData = responses[0].value && responses[0].value.data || {};
                        input.originData.members = '...';
                        input.external = { members: responses[1].value && responses[1].value.data && responses[1].value.data.rows || [] };
                        // info logic
                        $scope.model.info = $scope.model.info || {};
                        $scope.model.info.lines = $scope.model.info.lines || [{
                                text: input.originData.name,
                                class: 'file-name team-name'
                            }];
                        modulesDao.entityInfo('ms_teams', 'ms_teams_team').then(function (resp) {
                            input.entityInfo = resp.data || {};
                            // meta-info logic
                            var metaInfo = {
                                key: {},
                                value: {},
                                pair: { class: 'file-meta-data' },
                                args: {
                                    beautifyKey: true,
                                    whiteList: [
                                        {
                                            key: 'members',
                                            label: 'Members',
                                            type: 'external',
                                            externalEntity: 'ms_teams_user',
                                            externalKey: 'display_name',
                                            valueFormat: 'list',
                                            args: {
                                                collapseRest: true,
                                                expanded: 5,
                                                countPostfix: 'members',
                                                name: 'ms_teams_members',
                                                showAll: true
                                            }
                                        },
                                        'name',
                                        'description',
                                        {
                                            key: 'is_archived',
                                            hiddenPairAny: { value: false }
                                        },
                                        {
                                            key: 'visibility',
                                            hiddenPairAny: { value: null }
                                        },
                                        {
                                            key: 'is_external',
                                            hiddenPairAny: { value: false }
                                        }
                                    ]
                                }
                            };
                            metaInfo.data = metaInfoConverter(input, metaInfo.args);
                            $scope.model.metaInfo = metaInfo;
                            // actions
                            if ($scope.model.actionsWidget) {
                                $scope.model.actionsWidget.entityData = input.originData;
                            } else {
                                $scope.model.actionsWidget = {
                                    type: 'actions',
                                    logic: {
                                        name: 'remediationActionsLogic',
                                        updateTick: 30000,
                                        entityType: 'ms_teams_team',
                                        entityDataSlave: true
                                    },
                                    'class': 'team-info-actions-widget wide-250-buttons',
                                    wrapper: { type: 'none' },
                                    actions: rolesManager.isActionAllowed([
                                        'admin',
                                        'user',
                                        'operations'
                                    ]) ? [] : [],
                                    entityData: input.originData
                                };
                            }
                        });
                        if (restoreUpdateTickAfter && restoreUpdateTickAfter.isBefore(moment())) {
                            restoreUpdateTickAfter = null;
                            updateWidget = restartUpdating(updateWidget, updateTick);
                        }
                    }, function (err) {
                        console.log('Error in ms_teams team info:', err);
                    });
                };
                $scope.mainQueueDebug = mainQueueTroubleshootingHelper.button();
                updateWidget = $interval(function () {
                    $scope.loadData();
                }, updateTick);
                widgetPolling.on('remediationActionPerformed', function () {
                    restoreUpdateTickAfter = moment().add(30, 'seconds');
                    updateWidget = restartUpdating(updateWidget, 3000);
                });
                $scope.$on('$locationChangeStart', function () {
                    if (updateWidget) {
                        $interval.cancel(updateWidget);
                    }
                });
            }
        };
    }]);
}());